export enum eField {
  'email' = 2,
  'fullName' = 3,
  'dateBirth' = 4,
  'region' = 5,
  'photo' = 6,
  'password' = 7,
}

export enum EditFieldSection {
  'password' = 1,
  'phone' = 2,
  'email' = 3,
  'photo' = 4,
  'personalData' = 5,
}

export enum editField {
  'password' = 0,
  'phone' = 1,
  'email' = 2,
  'photo' = 3,
  'name' = 4,
  'region' = 5,
  'birthday' = 6,
}
